import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";

import { externalpageTypes } from "../../shared/services/externalpage.service";
import { AdminExternalpagesComponent } from "../admin-externalpages/admin-externalpages.component";

@Component({
  selector: "app-admin-events",
  templateUrl: "./admin-events.component.html",
  styleUrls: ["./admin-events.component.scss"],
  standalone: false,
})
export class AdminEventsComponent
  extends AdminExternalpagesComponent
  implements OnInit
{
  externalpageTypes = externalpageTypes;

  override configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: "Publication date",
        name: "publicationDate",
        type: "date",
      },
      {
        header_name: "Title",
        name: "title",
        type: "text",
      },
      {
        header_name: "Status",
        name: "status",
        type: "text",
      },
      {
        header_name: "Regions",
        name: "regions",
        type: "array",
      },
    ],
    endpoint: "externalpage",
    queryParams: {
      PageType: externalpageTypes.Event,
    },
    data: <any>[],
    buttons: [
      {
        class: "btn btn-danger btn-sm",
        event: "delete",
        text: "Delete",
      },
      {
        class: "btn btn-warning btn-sm",
        event: "edit",
        text: "Edit",
      },
      {
        class: "btn btn-info btn-sm",
        event: "duplicate",
        text: "Duplicate",
      },
    ],
    class: "",
    reloadListener: new Subject(),
  };

  override handleButtonEvent($event: any) {
    // Handle duplicate event
    if ($event.event === "duplicate") {
      this.duplicateEvent($event.data);
      return;
    }

    // Call parent method for other events (edit, delete)
    super.handleButtonEvent($event);
  }

  duplicateEvent(eventData: any) {
    // Navigate to the duplicate route with the original event ID
    this.router.navigate(["/admin/externalpage/Event/duplicate", eventData.id]);
  }
}
